/* unplugin-vue-components disabled */import script from "./operate.vue?vue&type=script&setup=true&lang=ts"
export * from "./operate.vue?vue&type=script&setup=true&lang=ts"

import "./operate.vue?vue&type=style&index=0&id=672d1052&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-672d1052"]])

export default __exports__